import { IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonDatetime, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonLabel, IonList, IonLoading, IonPage, IonPopover, IonRefresher, IonRefresherContent, IonRow, IonSelect, IonSelectOption, IonTitle, IonToast, IonToolbar, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import { alertCircle, arrowBack, arrowForwardCircle, checkmarkCircle, time, trash } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { deletarMensagem as deletarMensagemService, getEstatisticasMensagens, getMensagensEmpresa, requestService, urlBaseCore } from '../../../../../Utils/Services';
import "./PainelMensagens.css";

type Props = {
  abrirMenu: boolean;
  projetoid: string;
  empresaid: string;
  configs: Object;
  abrirInserirAgendamento: boolean;
  onDismiss: () => void;
};

const PainelMensagens: React.FC<Props> = (props: Props) => {
  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [listaMensagens, setListaMensagens] = useState<any>([]);
  const [nextToken, setNextToken] = useState<string | null>(null);
  const [carregandoMais, setCarregandoMais] = useState<boolean>(false);
  const [estatisticas, setEstatisticas] = useState<any>({});
  const [filtroStatus, setFiltroStatus] = useState("todos");
  const [filtroCampanha, setFiltroCampanha] = useState("todas");
  const [listaCampanhas, setListaCampanhas] = useState<any>([]);
  const [dataFiltro, setDataFiltro] = useState<string>(() => {
    // Inicializa com a data de hoje no formato YYYY-MM-DD
    const hoje = new Date();
    return hoje.toISOString().split('T')[0];
  });
  const [dataFiltroBr, setDataFiltroBr] = useState<string>(() => {
    // Inicializa com a data de hoje no formato brasileiro
    const hoje = new Date();
    return new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(hoje);
  });

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const { loja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { setEsconderMenu, setNomeMenu } = useContext(MessageContext);
  const [mostartAlerta] = useIonAlert();

  // Refs para popover de data
  const popoverData = useRef<HTMLIonPopoverElement>(null);
  const [showModalData, setShowModalData] = useState(false);

  useIonViewDidEnter(async () => {
    setEsconderMenu(false);
    setNomeMenu("Painel de Mensagens");
    await carregarCampanhas()
    carregarDados();
  });



  const carregarDados = async () => {
    await Promise.all([
      carregarMensagens(),
      carregarEstatisticas(),
    ]);
  };

  // Converte o nextToken (objeto ou string) para base64 de JSON, como o backend espera
  const encodeNextToken = (token: any): string | null => {
    try {
      if (!token) return null;
      // Se vier como objeto (pk/sk)
      if (typeof token === 'object') {
        const json = JSON.stringify(token);
        return btoa(unescape(encodeURIComponent(json)));
      }
      // Se já vier como string (por segurança, tenta detectar se já é base64)
      if (typeof token === 'string') {
        // Caso a API algum dia envie string JSON, ainda assim re-encode
        try {
          const maybeObj = JSON.parse(token);
          const json = JSON.stringify(maybeObj);
          return btoa(unescape(encodeURIComponent(json)));
        } catch {
          // Assume que já é base64
          return token;
        }
      }
      return null;
    } catch (e) {
      console.error('Falha ao codificar nextToken:', e);
      return null;
    }
  };

  const carregarMensagens = async () => {
    try {
      setShowLoading(true);

      let url = getMensagensEmpresa.url.replace("{empresaid}", loja.replaceAll(/#/g, '%23'));

      // Adicionar filtros na URL
      const params = new URLSearchParams();
      if (filtroStatus !== "todos") {
        params.append('status', filtroStatus);
      }
      if (filtroCampanha !== "todas") {
        params.append('campanha', filtroCampanha);
      }
      if (dataFiltro) {
        params.append('data', dataFiltro);
      }

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      await new Promise<void>((resolve, reject) => {
        requestService(
          url,
          {
            method: 'GET',
            timeout: 15000,
          },
          history,
          (response) => {
            const itens = response.Items || [];
            setListaMensagens(itens);
            const token = response?.pagination?.nextToken || null;
            setNextToken(token);
            resolve();
          },
          (error) => {
            console.error("Erro ao carregar mensagens:", error);
            if (error.status === 404) {
              setListaMensagens([]);
              setNextToken(null);
              resolve();
            } else {
              reject(new Error(error.message || "Erro ao carregar mensagens"));
            }
          }
        );
      });

    } catch (error: any) {
      console.error("Erro ao carregar mensagens:", error);
      setTextToast("Erro ao carregar mensagens.");
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }
  };

  const carregarMaisMensagens = async (ev?: CustomEvent) => {
    if (!nextToken || carregandoMais) {
      if (ev) (ev.target as HTMLIonInfiniteScrollElement).complete();
      return;
    }
    try {
      setCarregandoMais(true);

      let url = getMensagensEmpresa.url.replace("{empresaid}", loja.replaceAll(/#/g, '%23'));

      const params = new URLSearchParams();
      if (filtroStatus !== "todos") {
        params.append('status', filtroStatus);
      }
      if (filtroCampanha !== "todas") {
        params.append('campanha', filtroCampanha);
      }
      if (dataFiltro) {
        params.append('data', dataFiltro);
      }
      if (nextToken) {
        const encoded = encodeNextToken(nextToken);
        if (encoded) {
          params.append('nextToken', encoded);
        }
      }
      // evita cache do navegador/CDN
      params.append('_', Date.now().toString());

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const urlDebug = url;
      console.log('[Mensagens][Paginar] URL:', urlDebug);
      console.log('[Mensagens][Paginar] nextToken (orig):', nextToken);
      await new Promise<void>((resolve, reject) => {
        requestService(
          url,
          {
            method: 'GET',
            timeout: 15000,
          },
          history,
          (response) => {
            const novos = response.Items || [];
            setListaMensagens((prev: any[]) => {
              // evita duplicar itens (mesmo id)
              const ids = new Set(prev.map((m: any) => m.id || m.pk));
              const filtrados = novos.filter((m: any) => !ids.has(m.id || m.pk));
              return [...prev, ...filtrados];
            });
            const token = response?.pagination?.nextToken || null;
            setNextToken(token);
            resolve();
          },
          (error) => {
            console.error("Erro ao carregar mais mensagens:", error);
            reject(new Error(error.message || "Erro ao carregar mais mensagens"));
          }
        );
      });
    } catch (e) {
      // noop
    } finally {
      setCarregandoMais(false);
      if (ev) (ev.target as HTMLIonInfiniteScrollElement).complete();
    }
  };

  const carregarEstatisticas = async () => {
    try {
      let url = getEstatisticasMensagens.url.replace("{empresaid}", loja.replaceAll(/#/g, '%23'));

      // Adicionar parâmetro de data se selecionado
      const params = new URLSearchParams();
      if (filtroStatus !== "todos") {
        params.append('status', filtroStatus);
      }
      if (filtroCampanha !== "todas") {
        params.append('campanha', filtroCampanha);
      }
      if (dataFiltro) {
        params.append('data', dataFiltro);
      }

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      await new Promise<void>((resolve, reject) => {
        requestService(
          url,
          {
            method: 'GET',
            timeout: 15000,
          },
          history,
          (response) => {
            setEstatisticas(response);
            resolve();
          },
          (error) => {
            console.error("Erro ao carregar estatísticas:", error);
            setEstatisticas({});
            resolve(); // Não falhar se não conseguir carregar estatísticas
          }
        );
      });

    } catch (error: any) {
      console.error("Erro ao carregar estatísticas:", error);
      setEstatisticas({});
    }
  };

  const carregarCampanhas = async () => {
    try {
      const url = `${urlBaseCore.url}/campanhas/empresa/${loja.replaceAll(/#/g, '%23')}`;

      await new Promise<void>((resolve, reject) => {
        requestService(
          url,
          {
            method: 'GET',
            timeout: 15000,
          },
          history,
          (response) => {
            if (response.Items) {
              setListaCampanhas(response.Items);
            } else {
              setListaCampanhas([]);
            }
            resolve();
          },
          (error) => {
            console.error("Erro ao carregar campanhas:", error);
            setListaCampanhas([]);
            resolve();
          }
        );
      });

    } catch (error: any) {
      console.error("Erro ao carregar campanhas:", error);
      setListaCampanhas([]);
    }
  };

  const deletarMensagem = async (indice: number) => {
    mostartAlerta({
      backdropDismiss: false,
      header: 'Remover mensagem',
      message: 'Deseja <strong>remover</strong> esta mensagem?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
        },
        {
          text: 'Confirmar',
          cssClass: 'primary',
          handler: async () => {
            try {
              setShowLoading(true);

              const mensagem = listaMensagens[indice];

              console.log("********mensagem", mensagem.pk);

              const url = deletarMensagemService.url.replace("{id}", mensagem.pk.replaceAll(/#/g, '%23'));

              await new Promise<void>((resolve, reject) => {
                requestService(
                  url,
                  {
                    method: 'DELETE',
                    body: JSON.stringify({
                      pk: mensagem.pk,
                      sk: mensagem.sk,
                      empresaid: loja
                    }),
                    timeout: 15000,
                  },
                  history,
                  (response) => {
                    const novasMensagens = listaMensagens.filter((_: any, i: number) => i !== indice);
                    setListaMensagens(novasMensagens);
                    setTextToast("Mensagem removida com sucesso.");
                    setShowToast(true);

                    // Recarregar estatísticas após excluir mensagem
                    carregarEstatisticas();

                    resolve();
                  },
                  (error) => {
                    console.error("Erro ao deletar mensagem:", error);
                    setTextToast(error.message || "Erro ao deletar mensagem.");
                    setShowToast(true);
                    reject(new Error(error.message || "Erro ao deletar mensagem"));
                  }
                );
              });

            } catch (error: any) {
              console.error("Erro ao deletar mensagem:", error);
            } finally {
              setShowLoading(false);
            }
          }
        }
      ]
    });
  };



  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'aceita_meta': return { icon: checkmarkCircle, color: 'success' };
      case 'bloqueada_oficial':
      case 'nao_confirmado': return { icon: alertCircle, color: 'warning' };
      case 'recusada_meta': return { icon: alertCircle, color: 'danger' };
      case 'enfileirado_whatsapp': return { icon: arrowForwardCircle, color: 'tertiary' };
      case 'aguardando_processamento':
        return { icon: time, color: 'warning' };
      case 'enviado_para_fila':
        return { icon: arrowForwardCircle, color: 'tertiary' };
      case 'erro_processamento':
        return { icon: alertCircle, color: 'danger' };
      case 'erro_envio_whatsapp':
        return { icon: alertCircle, color: 'danger' };
      case 'enviado_whatsapp':
        return { icon: checkmarkCircle, color: 'success' };
      default:
        return { icon: time, color: 'medium' };
    }
  };

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'aceita_meta': return 'Aceita pela Meta (não confirma entrega)';
      case 'bloqueada_oficial': return 'Bloqueada no Oficial';
      case 'nao_confirmado': return 'Não confirmado — não reenviar';
      case 'recusada_meta': return 'Recusada pela Meta';
      case 'enfileirado_whatsapp': return 'Na fila do WhatsApp';
      case 'aguardando_processamento':
        return 'Aguardando';
      case 'enviado_para_fila':
        return 'Na Fila';
      case 'erro_processamento':
        return 'Erro';
      case 'erro_envio_whatsapp':
        return 'Erro envio WhatsApp';
      case 'enviado_whatsapp':
        return 'Enviado';
      default:
        return status;
    }
  };

  const formatarDataHora = (dataISO: string) => {
    if (!dataISO) return '-';
    try {
      const data = new Date(dataISO);
      return data.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return '-';
    }
  };

  // Função para abrir popover de seleção de data
  const openPopoverData = (e: any) => {
    popoverData.current!.event = e;
    setShowModalData(true);
  };

  const onRefresh = async (event: any) => {
    await carregarDados();
    event.detail.complete();
  };

  const loadMensagens = () => {
    if (!listaMensagens || listaMensagens.length === 0) {
      return (
        <IonItem lines="full" key={"semMensagens"}>
          <IonLabel>
            <h2 style={{ verticalAlign: "middle" }}><strong>Nenhuma mensagem encontrada</strong></h2>
          </IonLabel>
        </IonItem>
      );
    }

    return (
      <>
        {listaMensagens.map((mensagem: any, index: number) => {
          const statusInfo = getStatusIcon(mensagem.status);
          return (
            <IonItem lines="full" key={mensagem.id || index}>
              <IonLabel style={{ fontSize: "12px", width: "30px", minWidth: "30px", maxWidth: "30px" }}>
                <IonIcon
                  icon={statusInfo.icon}
                  color={statusInfo.color}
                  style={{ fontSize: '20px' }}
                />
              </IonLabel>
              <IonLabel style={{ fontSize: "12px", flex: 1, minWidth: "100px" }}>
                <div style={{ fontWeight: 'bold' }}>{mensagem.nome || 'Nome não informado'}</div>
                <div style={{ fontSize: '10px', color: '#666' }}>
                  📱 {mensagem.telefone}
                </div>
              </IonLabel>
              <IonLabel style={{ fontSize: "12px", textAlign: "center", width: "120px", minWidth: "120px", maxWidth: "120px" }}>
                <div style={{ fontWeight: 'bold' }}>{formatarDataHora(mensagem.dataExecucao)}</div>
                <div style={{ fontSize: '10px', color: '#666' }}>{getStatusLabel(mensagem.status)}</div>
              </IonLabel>
              <IonLabel style={{ fontSize: "10px", flex: 1, paddingRight: "80px" }}>
                <div style={{ fontSize: '10px', color: '#999' }}>
                  {mensagem.mensagem?.substring(0, 50)}{mensagem.mensagem?.length > 50 ? '...' : ''}
                </div>

                <div style={{ fontSize: '9px', color: '#666', marginTop: '2px' }}>
                  Delay: {mensagem.delay}s
                </div>

              </IonLabel>

              <div style={{ position: "absolute", right: "10px", zIndex: 9999999, backgroundColor: "#ffffff" }}>
                <IonButtons>

                  <IonButton
                    fill="clear"
                    onClick={() => deletarMensagem(index)}
                    hidden={acessos?.configuracoes !== 'edicao' || (mensagem.status !== 'aguardando_processamento')}
                  >
                    <IonIcon icon={trash} color="primary" />
                  </IonButton>
                </IonButtons>
              </div>
            </IonItem>
          );
        })}
      </>
    );
  };

  return (
    <IonPage className="PainelMensagens">
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack(); }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Painel de Mensagens</IonTitle>
        </IonToolbar>

      </IonHeader>

      <IonContent fullscreen={false}>
        <IonRefresher slot="fixed" onIonRefresh={onRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        {/* Filtros */}
        <IonCard>
          <IonCardContent>
            <h3 style={{ margin: '0 0 15px 0', fontWeight: 'bold' }}>Filtros</h3>
            <IonGrid>
              <IonRow>
                <IonCol size="12">
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                    <IonLabel style={{ marginRight: '10px', fontWeight: 'bold' }}>Data:</IonLabel>
                    <IonLabel
                      style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: '5px',
                        padding: '8px',
                        flex: 1,
                        cursor: 'pointer',
                        backgroundColor: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        minHeight: '40px'
                      }}
                      onClick={openPopoverData}
                    >
                      {dataFiltroBr || "Selecione uma data"}
                    </IonLabel>
                  </div>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol size="6">
                  <IonSelect
                    value={filtroStatus}
                    onIonChange={(e: any) => setFiltroStatus(e.detail.value)}
                    placeholder="Status"
                  >
                    <IonSelectOption value="todos">Todos os Status</IonSelectOption>
                    <IonSelectOption value="aguardando_processamento">Aguardando</IonSelectOption>
                    <IonSelectOption value="enviado_para_fila">Na Fila</IonSelectOption>
                    <IonSelectOption value="erro_processamento">Com Erro</IonSelectOption>
                    <IonSelectOption value="enviado_whatsapp">Enviado</IonSelectOption>
                    <IonSelectOption value="aceita_meta">Aceita pela Meta</IonSelectOption>
                    <IonSelectOption value="bloqueada_oficial">Bloqueada no Oficial</IonSelectOption>
                    <IonSelectOption value="recusada_meta">Recusada pela Meta</IonSelectOption>
                    <IonSelectOption value="nao_confirmado">Não confirmado</IonSelectOption>
                  </IonSelect>
                </IonCol>
                <IonCol size="6">
                  <IonSelect
                    value={filtroCampanha}
                    onIonChange={(e: any) => setFiltroCampanha(e.detail.value)}
                    placeholder="Campanha"
                  >
                    <IonSelectOption value="todas">Todas as Campanhas</IonSelectOption>
                    {listaCampanhas.map((campanha: any) => (
                      <IonSelectOption key={campanha.pk} value={campanha.pk}>
                        {campanha.nome}
                      </IonSelectOption>
                    ))}
                  </IonSelect>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol>
                  <IonButton
                    expand="block"
                    fill="outline"
                    onClick={async () => await carregarDados()}
                  >
                    Aplicar Filtros
                  </IonButton>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonCardContent>
        </IonCard>

        {/* Estatísticas */}
        <IonCard>
          <IonCardContent>
            <h3 style={{ margin: '0 0 15px 0', fontWeight: 'bold' }}>
              Estatísticas do Dia {dataFiltroBr && `(${dataFiltroBr})`}
            </h3>
            <IonGrid>
              <IonRow>
                <IonCol size="6">
                  <div style={{ textAlign: 'center', padding: '10px' }}>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#FBC604' }}>
                      {estatisticas.aguardando || 0}
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>Aguardando</div>
                  </div>
                </IonCol>
                <IonCol size="6">
                  <div style={{ textAlign: 'center', padding: '10px' }}>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1D3460' }}>
                      {estatisticas.fila || 0}
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>Na fila</div>
                  </div>
                </IonCol>

              </IonRow>
              <IonRow>
                <IonCol size="6">
                  <div style={{ textAlign: 'center', padding: '10px' }}>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#d4251c' }}>
                      {estatisticas.erro || 0}
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>Com Erro</div>
                  </div>
                </IonCol>
                <IonCol size="6">
                  <div style={{ textAlign: 'center', padding: '10px' }}>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#33ac1b' }}>
                      {estatisticas.enviadas || 0}
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>Enviadas</div>
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonCardContent>
        </IonCard>



        <IonList>
          <IonItem lines="none" style={{ fontWeight: 'bold', borderBottom: '1px solid #dddddd' }}>
            <IonLabel style={{ fontSize: "12px", width: "30px", minWidth: "30px", maxWidth: "30px" }}></IonLabel>
            <IonLabel style={{ fontSize: "12px", flex: 1, minWidth: "100px" }}>Destinatário</IonLabel>
            <IonLabel style={{ fontSize: "12px", textAlign: "center", width: "120px", minWidth: "120px", maxWidth: "120px" }}>Data/Hora</IonLabel>
            <IonLabel style={{ fontSize: "12px", flex: 1, paddingRight: "80px" }}>Mensagem</IonLabel>
          </IonItem>
        </IonList>

        {/* Lista de Mensagens */}
        <IonList>
          {loadMensagens()}
        </IonList>

        <IonInfiniteScroll
          onIonInfinite={async (ev) => await carregarMaisMensagens(ev)}
          threshold="100px"
          position="bottom"
          disabled={!nextToken}
        >
          <IonInfiniteScrollContent
            loadingSpinner="bubbles"
            loadingText="Carregando mais mensagens..."
          ></IonInfiniteScrollContent>
        </IonInfiniteScroll>

        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          spinner="circles"
        />

        <IonPopover ref={popoverData}
          isOpen={showModalData}
          onDidDismiss={() => setShowModalData(false)} >
          <IonContent>
            <IonDatetime
              presentation='date'
              onIonChange={e => {
                if (e.detail.value) {
                  let data = e.detail.value.toString().substring(0, 10);
                  const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                    Date.parse(data)
                  );

                  setDataFiltro(data); // Formato YYYY-MM-DD para API
                  setDataFiltroBr(dataFormatada); // Formato brasileiro para exibição
                }
                setShowModalData(false);
              }}></IonDatetime>
          </IonContent>
        </IonPopover >
      </IonContent>
    </IonPage>
  );
};

export default PainelMensagens;
